import { observable, action } from 'mobx';
import { saveAs } from 'file-saver';
import { http, addVisitLog, history } from 'libs';
import axios from 'axios';
import { message } from 'antd';
// import moment from "moment";

class Store {
  @observable records = [];
  @observable record = {};
  @observable isEdit = null;
  @observable fetching = false;
  @observable formVisible = false;
  @observable formLoading = false;
  @observable selectDisable = false;
  @observable userOptions = [];
  @observable applyUserOptions = [];
  @observable manageUserOptions = [];
  @observable projectUserOptions = [];
  @observable productList = [];
  @observable productOptions = [];
  @observable projectList = [];
  //搜索条件
  @observable page = 1;
  @observable pageSize = localStorage.getItem('customerFixedAssetsPageSize') || 10;
  @observable pageTotal = 0;
  @observable keywords = null;
  @observable deviceName = null;
  @observable brand = null;
  @observable factoryCode = null;
  @observable deviceSerialNo = null;
  @observable projectNo = null;
  @observable customerAssetNo = null;
  @observable contactPerson = null;
  @observable address = null;
  @observable receivProjectNo = null;
  @observable organizationName = null;
  @observable serviceType = null;
  @observable updatedName = null;
  @observable updateTime = null;

  pageChange = (page, size) => {
    this.records = []
    this.page = page;
    this.pageSize = size;
    localStorage.setItem('customerFixedAssetsPageSize',size);
    this.fetchRecords()
  }

  fetchProject = (orgCode) => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    const customerCode = userInfo.code;
    http.get('/javaApi/front/project/listAll',{ params: {orgCode:orgCode,sourceType:'CLINICAL',customerCode:customerCode,status:1} })
    .then(action('a', res => {
      this.projectList = res.data.result; 
  }))
  }

  fetchRecord = (info) => {
    this.record = {}
    this.isEdit = false
    if (info.id) {
      this.isEdit = true
      this.formLoading = true;
      let query = {
        id: info.id
      }
      http.get('/javaApi/front/customerFixedAssets/getDetail',{ params: query })
        .then(action('a', res => {
          this.record = res.data.result; 
      }))
        .finally(action('b', () => this.formLoading = false))
    }
  };

  fetchRecords = (type) => {
    this.fetching = true;
    let data = {
      pageNo: this.page,
      pageSize: this.pageSize,
      param:{
        deviceName: this.deviceName,
        brand: this.brand,
        factoryCode: this.factoryCode,
        deviceSerialNo: this.deviceSerialNo,
        organizationName: this.organizationName,
        projectNo: this.projectNo,
        customerAssetNo: this.customerAssetNo,
        keywords: this.keywords,
        address: this.address,
        contactPerson: this.contactPerson,
        receivProjectNo: this.receivProjectNo,
        serviceType: this.serviceType,
        updatedName: this.updatedName,
        startDate: this.updateTime&&this.updateTime[0],
        endDate: this.updateTime&&this.updateTime[1],
      }
    }
    if (type) {
      addVisitLog({
        pageName: '搜索客户固资',
        fromPageUrl: window.referrerUrl,
        pageUrl:`${window.location.origin}${history.location.pathname}`,
        eventCode: 'SearchCustomerFixedAssets',
        eventName: "搜索客户固资",
        content: JSON.stringify(data),
      })
    }
    http.post('/javaApi/front/customerFixedAssets/list',data)
      .then(action('a', res => {
        const result = res.data.result
        this.records = result.data
        this.pageTotal = result.pageInfo.totalRows;
    }))
      .finally(action('b', () => this.fetching = false))
  };

 async exportLog(data) {
    const url = '/javaApi/front/customerFixedAssets/clinicaExport';
    const res = await axios({
      url: url,
      method: 'post',
      data:data,
      responseType: 'arraybuffer',
      headers: {
        token: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return res;
  }

  onExport = () => {
    let query = {
      pageNo: this.page,
      pageSize: this.pageSize,
      deviceName: this.deviceName,
      brand: this.brand,
      factoryCode: this.factoryCode,
      deviceSerialNo: this.deviceSerialNo,
      organizationName: this.organizationName,
      projectNo: this.projectNo,
      customerAssetNo: this.customerAssetNo,
      keywords: this.keywords,
      address: this.address,
      contactPerson: this.contactPerson,
      receivProjectNo: this.receivProjectNo,
      serviceType: this.serviceType,
      updatedName: this.updatedName,
      startDate: this.updateTime&&this.updateTime[0],
      endDate: this.updateTime&&this.updateTime[1],
    }
    this.exportLog(query).then(res => {
      if (res) {
        let url = window.URL.createObjectURL(
          new Blob([res.data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          }),
        );
        saveAs(url,'客户固资列表.xls');
      } else {
        message.error('导出失败');
      }
    });
    addVisitLog({
      pageName: '导出客户固资',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "ExportCustomerFixedAssets",
      eventName: "导出客户固资",
    })
  }
  onImport = (params) => {
      return http({
          url: '/javaApi/front/customerFixedAssets/importExc',
          method: 'post',
          data: params,
          headers: { 'Content-Type': 'multipart/form-data' }
      });
  }

  onRowsChange = (rows, keys) => {
    console.log(rows, keys)
  }

  showForm = (info) => {
    this.projectList = [];
    this.record = {};
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    const accountCode = userInfo.accountCode;
    this.fetchProject(accountCode);
    if (info.id) {
      this.fetchRecord(info);
      // this.fetchProject(info.organizationName);
    }
    this.formVisible = true;
  }
}

export default new Store()